// @ts-nocheck
/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import axios from 'axios';
import type { AxiosError, AxiosRequestConfig, AxiosResponse } from 'axios';
import type {
  CohortUpdateRequest,
  GenericApiResponse,
  GenericApiResponseCohort,
  GetAllCohortsCohortsGetParams,
  HTTPValidationError,
} from '../../models';

/**
 * Get all cohorts
 * @summary Get All Cohorts
 */
export const getAllCohortsCohortsGet = (
  params?: GetAllCohortsCohortsGetParams,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  return axios.get(`/cohorts`, {
    ...options,
    params: { ...params, ...options?.params },
  });
};

export const getGetAllCohortsCohortsGetQueryKey = (params?: GetAllCohortsCohortsGetParams) => {
  return [`/cohorts`, ...(params ? [params] : [])] as const;
};

export const getGetAllCohortsCohortsGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getAllCohortsCohortsGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetAllCohortsCohortsGetParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCohortsCohortsGet>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAllCohortsCohortsGetQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllCohortsCohortsGet>>> = ({ signal }) =>
    getAllCohortsCohortsGet(params, { signal, ...axiosOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAllCohortsCohortsGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAllCohortsCohortsGetQueryResult = NonNullable<Awaited<ReturnType<typeof getAllCohortsCohortsGet>>>;
export type GetAllCohortsCohortsGetQueryError = AxiosError<void | HTTPValidationError>;

export function useGetAllCohortsCohortsGet<
  TData = Awaited<ReturnType<typeof getAllCohortsCohortsGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params: undefined | GetAllCohortsCohortsGetParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCohortsCohortsGet>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getAllCohortsCohortsGet>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllCohortsCohortsGet<
  TData = Awaited<ReturnType<typeof getAllCohortsCohortsGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetAllCohortsCohortsGetParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCohortsCohortsGet>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getAllCohortsCohortsGet>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAllCohortsCohortsGet<
  TData = Awaited<ReturnType<typeof getAllCohortsCohortsGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetAllCohortsCohortsGetParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCohortsCohortsGet>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get All Cohorts
 */

export function useGetAllCohortsCohortsGet<
  TData = Awaited<ReturnType<typeof getAllCohortsCohortsGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  params?: GetAllCohortsCohortsGetParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllCohortsCohortsGet>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAllCohortsCohortsGetQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Create cohort
 * @summary Create Cohort
 */
export const createCohortCohortsPost = (
  cohortUpdateRequest: CohortUpdateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  return axios.post(`/cohorts`, cohortUpdateRequest, options);
};

export const getCreateCohortCohortsPostMutationOptions = <
  TData = Awaited<ReturnType<typeof createCohortCohortsPost>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: CohortUpdateRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['createCohortCohortsPost'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCohortCohortsPost>>,
    { data: CohortUpdateRequest }
  > = (props) => {
    const { data } = props ?? {};

    return createCohortCohortsPost(data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: CohortUpdateRequest },
    TContext
  >;
};

export type CreateCohortCohortsPostMutationResult = NonNullable<Awaited<ReturnType<typeof createCohortCohortsPost>>>;
export type CreateCohortCohortsPostMutationBody = CohortUpdateRequest;
export type CreateCohortCohortsPostMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Create Cohort
 */
export const useCreateCohortCohortsPost = <
  TData = Awaited<ReturnType<typeof createCohortCohortsPost>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: CohortUpdateRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { data: CohortUpdateRequest }, TContext> => {
  const mutationOptions = getCreateCohortCohortsPostMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Get cohort
 * @summary Get Cohort
 */
export const getCohortCohortsCohortIdGet = (
  cohortId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  return axios.get(`/cohorts/${cohortId}`, options);
};

export const getGetCohortCohortsCohortIdGetQueryKey = (cohortId: string) => {
  return [`/cohorts/${cohortId}`] as const;
};

export const getGetCohortCohortsCohortIdGetQueryOptions = <
  TData = Awaited<ReturnType<typeof getCohortCohortsCohortIdGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  cohortId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohortCohortsCohortIdGet>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
) => {
  const { query: queryOptions, axios: axiosOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetCohortCohortsCohortIdGetQueryKey(cohortId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCohortCohortsCohortIdGet>>> = ({ signal }) =>
    getCohortCohortsCohortIdGet(cohortId, { signal, ...axiosOptions });

  return { queryKey, queryFn, enabled: !!cohortId, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getCohortCohortsCohortIdGet>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCohortCohortsCohortIdGetQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCohortCohortsCohortIdGet>>
>;
export type GetCohortCohortsCohortIdGetQueryError = AxiosError<void | HTTPValidationError>;

export function useGetCohortCohortsCohortIdGet<
  TData = Awaited<ReturnType<typeof getCohortCohortsCohortIdGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  cohortId: string,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohortCohortsCohortIdGet>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<Awaited<ReturnType<typeof getCohortCohortsCohortIdGet>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCohortCohortsCohortIdGet<
  TData = Awaited<ReturnType<typeof getCohortCohortsCohortIdGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  cohortId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohortCohortsCohortIdGet>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<Awaited<ReturnType<typeof getCohortCohortsCohortIdGet>>, TError, TData>,
        'initialData'
      >;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetCohortCohortsCohortIdGet<
  TData = Awaited<ReturnType<typeof getCohortCohortsCohortIdGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  cohortId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohortCohortsCohortIdGet>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get Cohort
 */

export function useGetCohortCohortsCohortIdGet<
  TData = Awaited<ReturnType<typeof getCohortCohortsCohortIdGet>>,
  TError = AxiosError<void | HTTPValidationError>,
>(
  cohortId: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getCohortCohortsCohortIdGet>>, TError, TData>>;
    axios?: AxiosRequestConfig;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetCohortCohortsCohortIdGetQueryOptions(cohortId, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

/**
 * Update cohort
 * @summary Update Cohort
 */
export const updateCohortCohortsCohortIdPut = (
  cohortId: string,
  cohortUpdateRequest: CohortUpdateRequest,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponseCohort>> => {
  return axios.put(`/cohorts/${cohortId}`, cohortUpdateRequest, options);
};

export const getUpdateCohortCohortsCohortIdPutMutationOptions = <
  TData = Awaited<ReturnType<typeof updateCohortCohortsCohortIdPut>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { cohortId: string; data: CohortUpdateRequest }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['updateCohortCohortsCohortIdPut'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateCohortCohortsCohortIdPut>>,
    { cohortId: string; data: CohortUpdateRequest }
  > = (props) => {
    const { cohortId, data } = props ?? {};

    return updateCohortCohortsCohortIdPut(cohortId, data, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { cohortId: string; data: CohortUpdateRequest },
    TContext
  >;
};

export type UpdateCohortCohortsCohortIdPutMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateCohortCohortsCohortIdPut>>
>;
export type UpdateCohortCohortsCohortIdPutMutationBody = CohortUpdateRequest;
export type UpdateCohortCohortsCohortIdPutMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Update Cohort
 */
export const useUpdateCohortCohortsCohortIdPut = <
  TData = Awaited<ReturnType<typeof updateCohortCohortsCohortIdPut>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { cohortId: string; data: CohortUpdateRequest }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { cohortId: string; data: CohortUpdateRequest }, TContext> => {
  const mutationOptions = getUpdateCohortCohortsCohortIdPutMutationOptions(options);

  return useMutation(mutationOptions);
};
/**
 * Delete cohort
 * @summary Delete Cohort
 */
export const deleteCohortCohortsCohortIdDelete = (
  cohortId: string,
  options?: AxiosRequestConfig,
): Promise<AxiosResponse<GenericApiResponse>> => {
  return axios.delete(`/cohorts/${cohortId}`, options);
};

export const getDeleteCohortCohortsCohortIdDeleteMutationOptions = <
  TData = Awaited<ReturnType<typeof deleteCohortCohortsCohortIdDelete>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { cohortId: string }, TContext>;
  axios?: AxiosRequestConfig;
}) => {
  const mutationKey = ['deleteCohortCohortsCohortIdDelete'];
  const { mutation: mutationOptions, axios: axiosOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, axios: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteCohortCohortsCohortIdDelete>>,
    { cohortId: string }
  > = (props) => {
    const { cohortId } = props ?? {};

    return deleteCohortCohortsCohortIdDelete(cohortId, axiosOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<TData, TError, { cohortId: string }, TContext>;
};

export type DeleteCohortCohortsCohortIdDeleteMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteCohortCohortsCohortIdDelete>>
>;

export type DeleteCohortCohortsCohortIdDeleteMutationError = AxiosError<void | HTTPValidationError>;

/**
 * @summary Delete Cohort
 */
export const useDeleteCohortCohortsCohortIdDelete = <
  TData = Awaited<ReturnType<typeof deleteCohortCohortsCohortIdDelete>>,
  TError = AxiosError<void | HTTPValidationError>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { cohortId: string }, TContext>;
  axios?: AxiosRequestConfig;
}): UseMutationResult<TData, TError, { cohortId: string }, TContext> => {
  const mutationOptions = getDeleteCohortCohortsCohortIdDeleteMutationOptions(options);

  return useMutation(mutationOptions);
};
